
export default {
    name: 'GameHeader',
    props: {
        releaseData: {
            type: Object,
            default: () => { }
        },
        btnText: {
            type: String,
            default: '上一步'
        }
    },
    computed: {
        displayTitle() {
            const title = [this.releaseData.gameName]
            if(this.releaseData.goodsCatalogueName) {
                title.push(this.releaseData.goodsCatalogueName)
            }
            // if(+this.releaseData?.goodsCatalogueId === 6) {
            //     title.push()
            // }
            // 成品号 再说吧
            return title
        },
        gameIconUrl() {
            return this.releaseData.pcIconUrl
        }
    },
    methods: {
        reselectBtn() {
            this.$emit('reselectBtn')
        }
    }
}
